// extracted by mini-css-extract-plugin
module.exports = {"controls__container":"controls__container-EHmcK","controls__control":"controls__control-zO84P","controls__controlImg":"controls__controlImg-EG5Ho"};